// Config
import type { InitConfig, ResignFormConfig } from '@solidgate/react-sdk';

export const WAIT_BEFORE_NEXT_CHECK_ORDER_PAYMENT_STATUS_MS = 1500; // 5 seconds

export const TIMEOUT_BEFORE_ERROR_S = 5; // seconds before showing error message if payment is still pending
export const TIMEOUT_BEFORE_READY_MS = 750; // milliseconds before showing the payment form -> prevent flickering

export const SOLIDGATE_FORM_CARD_ENOUGH_WIDTH = 425; // custom breakpoint for card form variant (Card, Default)

export const SOLIDGATE_PAYMENT_CARDS = ['visa', 'mastercard', 'discover', 'amex', 'diners-club', 'eftpos-australia', 'jcb', 'union-pay'];

export const SOLIDGATE_FORM_CONFIG: Pick<InitConfig, 'styles' | 'googlePayButtonParams' | 'applePayButtonParams' | 'formParams'> = {
  styles: {
    primaryColor: '#000000',
    fontFamily: 'Nunito, SFProText, -apple-system, sans-serif',
    fontSize: '16px',
    borderRadius: '24px',
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#cccccc',
    inputTextColor: '#333333',
    inputPlaceholderColor: '#999999',
    padding: 0,
    /* eslint-disable camelcase */
    submit_button: {
      background: '#00816a',
      'font-size': '1em',
      'font-weight': 500,
      'text-transform': 'none',
      'letter-spacing': '-1px !important',
      'box-shadow': 'none',
      'border-radius': '10px',
      margin: '0 auto',
    },
  },
  googlePayButtonParams: {
    color: 'white',
  },

  applePayButtonParams: {
    integrationType: 'js',
    type: 'plain',
  },

  formParams: {
    submitButtonText: 'Pay Now',
    isCardHolderVisible: false,
    isSolidLogoVisible: false,
    cardCvvPlaceholder: 'CVV',
    autoFocus: true,
  },
};

export const SOLIDGATE_RESIGN_CONFIG: ResignFormConfig = {
  appearance: {
    submitButtonText: 'Pay Now',
    allowSubmit: true,
    resignCvvLabel: 'CVV',
    resignCvvPlaceholder: '123',
    hideCvvNumbers: true,
  },
};
